import { render, staticRenderFns } from "./AboutHomeEight.vue?vue&type=template&id=012070be&"
import script from "./AboutHomeEight.vue?vue&type=script&lang=js&"
export * from "./AboutHomeEight.vue?vue&type=script&lang=js&"
import style0 from "./AboutHomeEight.vue?vue&type=style&index=0&id=012070be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports